// @ts-nocheck

/**
 * * `existing_character` - Existing Character
 * `from_asset` - From Asset
 * `from_prompt` - From Prompt
 */
export type ModeEnum = typeof ModeEnum[keyof typeof ModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModeEnum = {
  existing_character: "existing_character",
  from_asset: "from_asset",
  from_prompt: "from_prompt",
} as const;
